"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M.33 11.665c.036-.074.103-.201.202-.376a20.245 20.245 0 012.796-3.802C5.8 4.849 8.7 3.25 12 3.25c3.3 0 6.2 1.6 8.672 4.237a20.245 20.245 0 012.796 3.802c.099.175.166.302.203.376a.75.75 0 010 .67 9.492 9.492 0 01-.203.376 20.245 20.245 0 01-2.796 3.802C18.2 19.151 15.3 20.75 12 20.75c-3.3 0-6.2-1.6-8.672-4.237a20.245 20.245 0 01-2.796-3.802 9.492 9.492 0 01-.203-.376.75.75 0 010-.67zm2.034 1.178a18.76 18.76 0 002.058 2.644C6.637 17.849 9.175 19.25 12 19.25s5.363-1.4 7.578-3.763A18.76 18.76 0 0022.148 12a18.76 18.76 0 00-2.57-3.487C17.363 6.151 14.825 4.75 12 4.75s-5.363 1.4-7.578 3.763A18.76 18.76 0 001.852 12c.144.254.315.538.512.843zM12 15.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm0-1.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  }));
};
SvgEye.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgEye.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgEye;
exports["default"] = _default;
module.exports = exports.default;